'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');let

GroupNotificationSettingsDirective=function(_BaseControllerBacked){_inherits(GroupNotificationSettingsDirective,_BaseControllerBacked);function GroupNotificationSettingsDirective(){_classCallCheck(this,GroupNotificationSettingsDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(GroupNotificationSettingsDirective,[{key:'objectBindings',get:function()
{
return[
'group'];

}},{key:'templateUrl',get:function()

{
return'/templates/features/notificationSettings/components/groupNotificationSettingsDirective/groupNotificationSettingsTemplate';
}},{key:'controller',get:function()

{
return GroupNotificationSettingsController;
}}]);return GroupNotificationSettingsDirective}(BaseControllerBackedDirective);let


GroupNotificationSettingsController=function(_BaseController){_inherits(GroupNotificationSettingsController,_BaseController);_createClass(GroupNotificationSettingsController,null,[{key:'$inject',get:function()
{return['$scope','uncaughtErrorHandler']}}]);

function GroupNotificationSettingsController($scope,uncaughtErrorHandler){_classCallCheck(this,GroupNotificationSettingsController);var _this2=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

_this2._selectedNotificationType=_this2.group.notificationType;
_this2._isOpened=!1;

$scope.$watch('controller.group.notificationType',function(newNotificationType){
if(_this2._selectedNotificationType===newNotificationType){
return;
}

_this2._selectedNotificationType=newNotificationType;
});return _this2;
}GroupNotificationSettingsController.prototype.























toggleAccordian=function toggleAccordian(){
this._isOpened=!this._isOpened;
};_createClass(GroupNotificationSettingsController,[{key:'selectedNotificationType',get:function(){return this._selectedNotificationType},set:function(notificationType){if(!_.exists(NotificationType[notificationType])){return}this._selectedNotificationType=notificationType;if(this.group.notificationType===notificationType){return}this.group.notificationTypeChangedCommand.execute(notificationType)}},{key:'isOpened',get:function(){return this._isOpened}}]);return GroupNotificationSettingsController}(BaseController);


module.exports=GroupNotificationSettingsDirective;
module.exports.controller=GroupNotificationSettingsController;
//# sourceMappingURL=groupNotificationSettingsDirective.js.map
